import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { EditableList } from '../../generic/EditableList';
import { Stack } from '@mui/material';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const EditableListWidget = () => {
    const component = useMemo(() => (_jsx(Stack, { direction: "row", children: _jsx(EditableList, { currentList: ['Value A', 'Value B'], setCurrentList: () => { } }) })), []);
    return {
        name: 'EditableList',
        category: 'generic',
        component,
    };
};
